import { render, staticRenderFns } from "./DocumentInformationStep.vue?vue&type=template&id=054d7b03&scoped=true&"
import script from "./DocumentInformationStep.vue?vue&type=script&lang=js&"
export * from "./DocumentInformationStep.vue?vue&type=script&lang=js&"
import style0 from "./DocumentInformationStep.vue?vue&type=style&index=0&id=054d7b03&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054d7b03",
  null
  
)

export default component.exports